import Tooltip from '@components/Presentation/atoms/Tooltip';
import Link from 'next/link';

type SidebarMenuItemProps = {
  label: string;
  icon?: React.ReactNode;
  isExpanded: boolean;
  isActive?: boolean;
  href?: string;
  onClick?: () => void;
  badge?: React.ReactNode;
  tooltipPlacement?: 'left' | 'right' | 'top' | 'bottom';
}

export default function SidebarMenuItem({
  label,
  icon,
  isExpanded,
  isActive = false,
  href,
  onClick,
  badge,
  tooltipPlacement = 'left'
}: SidebarMenuItemProps) {
  const activeClass = isActive
    ? 'bg-primary-500/20 text-primary-500'
    : 'text-default-700 hover:bg-content3';

  const content = (
    <>
      {icon && (
        <div className='w-5 h-5 flex items-center'>
          {icon}
        </div>
      )}
      {isExpanded && (
        <>
          <span className='text-sm'>{label}</span>
          {badge}
        </>
      )}
    </>
  );

  const className = `rounded-md flex items-center px-2 py-1.5 h-8 gap-4 w-full text-left ${activeClass} ${onClick ? 'cursor-pointer' : ''}`;

  return (
    <Tooltip
      content={label}
      placement={tooltipPlacement}
      isDisabled={isExpanded}
    >
      {href ? (
        <Link href={href} className={className} onClick={onClick}>
          {content}
        </Link>
      ) : (
        <button onClick={onClick} className={className}>
          {content}
        </button>
      )}
    </Tooltip>
  );
}
